export default {
  s3: {
    REGION: "YOUR_S3_UPLOADS_BUCKET_REGION",
    BUCKET: "YOUR_S3_UPLOADS_BUCKET_NAME"
  },
  // DEV
  apiGateway: {
    REGION: process.env.REACT_APP_AWS_REGION,
    URL: process.env.REACT_APP_API_URL
  },
  cognito: {
    REGION: process.env.REACT_APP_AWS_REGION,
    USER_POOL_ID: process.env.REACT_APP_COGNITO_USER_POOL_ID,
    APP_CLIENT_ID: process.env.REACT_APP_COGNITO_APP_CLIENT_ID,
    // IDENTITY_POOL_ID: "9de18f08-ad8a-44f9-864b-49306b6b4a81"
    // IDENTITY_POOL_ID: "eu-central-1:7ed924ad-dc68-490d-804a-7229ac25a478"
  },
  website: {
    URL: process.env.REACT_APP_WWW_URL
  }

  // // PROD
  // apiGateway: {
  //   REGION: "eu-central-1",
  //   URL: "https://b8agf6cihg.execute-api.eu-central-1.amazonaws.com/prod"
  // },
  // cognito: {
  //   REGION: "eu-central-1",
  //   USER_POOL_ID: "eu-central-1_FcAtn9soN",
  //   APP_CLIENT_ID: "4v2a7viinburkau0bpckvq6dbb",
  //   // IDENTITY_POOL_ID: "9de18f08-ad8a-44f9-864b-49306b6b4a81"
  //   // IDENTITY_POOL_ID: "arn:aws:cognito-idp:eu-central-1:471144442296:userpool/eu-central-1_FcAtn9soN"
  // }
  
  // CREAGAIA
  // apiGateway: {
  //   REGION: "eu-central-1",
  //   URL: "https://9j8qw7nei2.execute-api.eu-central-1.amazonaws.com/dev"
  // },
  // cognito: {
  //   REGION: "eu-central-1",
  //   USER_POOL_ID: "eu-central-1_3Fti23HJs",
  //   APP_CLIENT_ID: "bna2j3p85e2vcjpgqfdgt17jp"
  // }
};



